/**
 * Custom SVG icons for Manifold Careers features
 * Design: Blueprint + pencil aesthetic
 * Colors: Coral (#d4736a), Yellow (#f7c948), Graphite (#3d3d3d), Off-white (#fffef9)
 */

import React from 'react';

// AI Job Analysis - Target/bullseye with pencil marks
export const AnalysisIcon = ({ size = 48 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
    <circle cx="24" cy="24" r="18" stroke="#e8e8e8" strokeWidth="2" strokeDasharray="4 2"/>
    <circle cx="24" cy="24" r="12" stroke="#3d3d3d" strokeWidth="1.5" opacity="0.6"/>
    <circle cx="24" cy="24" r="6" fill="#d4736a" opacity="0.9"/>
    <path d="M24 6 L24 10" stroke="#f7c948" strokeWidth="2" strokeLinecap="round"/>
    <path d="M24 38 L24 42" stroke="#f7c948" strokeWidth="2" strokeLinecap="round"/>
    <path d="M6 24 L10 24" stroke="#f7c948" strokeWidth="2" strokeLinecap="round"/>
    <path d="M38 24 L42 24" stroke="#f7c948" strokeWidth="2" strokeLinecap="round"/>
    <path d="M32 16 Q28 20, 24 24" stroke="#3d3d3d" strokeWidth="1" fill="none" strokeLinecap="round" opacity="0.5"/>
  </svg>
);

// Resume Tailoring - Document with pencil
export const ResumeIcon = ({ size = 48 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
    <rect x="10" y="6" width="24" height="32" rx="2" fill="#fffef9" stroke="#3d3d3d" strokeWidth="1.5"/>
    <path d="M14 14 L26 14" stroke="#e8e8e8" strokeWidth="2" strokeLinecap="round"/>
    <path d="M14 20 L30 20" stroke="#d4736a" strokeWidth="2" strokeLinecap="round"/>
    <path d="M14 26 L28 26" stroke="#e8e8e8" strokeWidth="2" strokeLinecap="round"/>
    <path d="M14 32 L22 32" stroke="#e8e8e8" strokeWidth="2" strokeLinecap="round"/>
    <g transform="translate(28, 28) rotate(-45)">
      <rect x="0" y="0" width="14" height="4" fill="#f7c948" stroke="#d4a832" strokeWidth="0.5"/>
      <polygon points="0,0 0,4 -3,2" fill="#c9a87c"/>
      <polygon points="-3,2 -1,1 -1,3" fill="#3d3d3d"/>
    </g>
  </svg>
);

// Career Insights - Chart with upward trend
export const InsightsIcon = ({ size = 48 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
    <rect x="8" y="8" width="32" height="28" rx="2" fill="none" stroke="#e8e8e8" strokeWidth="1.5" strokeDasharray="4 2"/>
    <path d="M12 32 L12 24" stroke="#3d3d3d" strokeWidth="4" strokeLinecap="round" opacity="0.4"/>
    <path d="M20 32 L20 20" stroke="#3d3d3d" strokeWidth="4" strokeLinecap="round" opacity="0.6"/>
    <path d="M28 32 L28 16" stroke="#d4736a" strokeWidth="4" strokeLinecap="round"/>
    <path d="M36 32 L36 12" stroke="#f7c948" strokeWidth="4" strokeLinecap="round"/>
    <path d="M10 32 Q18 26, 24 22 T38 10" stroke="#3d3d3d" strokeWidth="1.5" fill="none" strokeLinecap="round" opacity="0.5"/>
    <circle cx="38" cy="10" r="2.5" fill="#d4736a"/>
  </svg>
);

// Skill Development - Building blocks / construction
export const SkillsIcon = ({ size = 48 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
    <rect x="8" y="28" width="12" height="12" fill="#e8e8e8" stroke="#3d3d3d" strokeWidth="1"/>
    <rect x="18" y="20" width="12" height="20" fill="#f7c948" stroke="#d4a832" strokeWidth="1"/>
    <rect x="28" y="12" width="12" height="28" fill="#d4736a" stroke="#c4635a" strokeWidth="1"/>
    <path d="M4 40 L44 40" stroke="#3d3d3d" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M34 8 L34 12" stroke="#3d3d3d" strokeWidth="1.5" strokeLinecap="round" opacity="0.5"/>
    <path d="M32 10 L36 10" stroke="#3d3d3d" strokeWidth="1.5" strokeLinecap="round" opacity="0.5"/>
    <circle cx="14" cy="34" r="1.5" fill="#3d3d3d" opacity="0.3"/>
    <circle cx="24" cy="30" r="1.5" fill="#3d3d3d" opacity="0.3"/>
    <circle cx="34" cy="26" r="1.5" fill="white" opacity="0.5"/>
  </svg>
);

// Interview Prep - Speech bubble with checklist
export const InterviewIcon = ({ size = 48 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
    <path d="M8 10 L40 10 L40 32 L24 32 L16 40 L16 32 L8 32 Z" fill="#fffef9" stroke="#3d3d3d" strokeWidth="1.5"/>
    <path d="M14 17 L18 17" stroke="#d4736a" strokeWidth="2" strokeLinecap="round"/>
    <path d="M22 17 L34 17" stroke="#e8e8e8" strokeWidth="2" strokeLinecap="round"/>
    <path d="M14 23 L18 23" stroke="#f7c948" strokeWidth="2" strokeLinecap="round"/>
    <path d="M22 23 L32 23" stroke="#e8e8e8" strokeWidth="2" strokeLinecap="round"/>
    <circle cx="16" cy="17" r="2" fill="none" stroke="#d4736a" strokeWidth="1.5"/>
    <path d="M14.5 17 L15.5 18 L17.5 15.5" stroke="#d4736a" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="16" cy="23" r="2" fill="none" stroke="#f7c948" strokeWidth="1.5"/>
  </svg>
);

// Job Tracker - Kanban/list view
export const TrackerIcon = ({ size = 48 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
    <rect x="6" y="8" width="36" height="32" rx="2" fill="#fffef9" stroke="#3d3d3d" strokeWidth="1.5"/>
    <path d="M6 16 L42 16" stroke="#e8e8e8" strokeWidth="1.5"/>
    <rect x="10" y="20" width="10" height="6" rx="1" fill="#d4736a" opacity="0.8"/>
    <rect x="10" y="28" width="14" height="6" rx="1" fill="#f7c948" opacity="0.8"/>
    <rect x="28" y="20" width="8" height="6" rx="1" fill="#e8e8e8"/>
    <rect x="28" y="28" width="10" height="6" rx="1" fill="#e8e8e8"/>
    <circle cx="12" cy="12" r="2" fill="#d4736a"/>
    <circle cx="18" cy="12" r="2" fill="#f7c948"/>
    <circle cx="24" cy="12" r="2" fill="#5a8f5a"/>
  </svg>
);

// Gap Analysis - Venn diagram / comparison
export const GapIcon = ({ size = 48 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
    <circle cx="18" cy="24" r="14" fill="none" stroke="#d4736a" strokeWidth="2" strokeDasharray="4 2"/>
    <circle cx="30" cy="24" r="14" fill="none" stroke="#f7c948" strokeWidth="2" strokeDasharray="4 2"/>
    <path d="M24 14 Q24 24, 24 34" stroke="#3d3d3d" strokeWidth="1.5" strokeLinecap="round" opacity="0.4"/>
    <circle cx="24" cy="24" r="4" fill="#5a8f5a" opacity="0.6"/>
    <path d="M12 18 L14 20 L16 16" stroke="#d4736a" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M32 28 L34 30 L36 26" stroke="#f7c948" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Job Radar - Radar/signal icon
export const RadarIcon = ({ size = 48 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
    <circle cx="24" cy="24" r="18" stroke="#e8e8e8" strokeWidth="1.5" strokeDasharray="4 2"/>
    <circle cx="24" cy="24" r="12" stroke="#f7c948" strokeWidth="1.5" strokeDasharray="4 2"/>
    <circle cx="24" cy="24" r="6" stroke="#d4736a" strokeWidth="1.5"/>
    <path d="M24 6 L24 24" stroke="#3d3d3d" strokeWidth="2" strokeLinecap="round"/>
    <circle cx="24" cy="24" r="2" fill="#d4736a"/>
    <circle cx="32" cy="16" r="3" fill="#f7c948" opacity="0.8"/>
    <circle cx="16" cy="20" r="2" fill="#5a8f5a" opacity="0.6"/>
    <path d="M24 24 L32 16" stroke="#3d3d3d" strokeWidth="1" opacity="0.4"/>
  </svg>
);

// Settings Gear icon
export const SettingsIcon = ({ size = 48 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
    <circle cx="24" cy="24" r="8" stroke="#3d3d3d" strokeWidth="2" fill="#fffef9"/>
    <circle cx="24" cy="24" r="3" fill="#d4736a"/>
    {[0, 45, 90, 135, 180, 225, 270, 315].map((angle, i) => (
      <rect
        key={i}
        x="22"
        y="4"
        width="4"
        height="8"
        rx="1"
        fill={i % 2 === 0 ? '#f7c948' : '#3d3d3d'}
        opacity={i % 2 === 0 ? 1 : 0.6}
        transform={`rotate(${angle} 24 24)`}
      />
    ))}
  </svg>
);

// Profile/User icon
export const ProfileIcon = ({ size = 48 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
    <circle cx="24" cy="18" r="8" fill="#fffef9" stroke="#3d3d3d" strokeWidth="1.5"/>
    <path d="M10 42 Q10 30, 24 30 Q38 30, 38 42" fill="#f7c948" stroke="#d4a832" strokeWidth="1"/>
    <circle cx="24" cy="18" r="4" fill="#d4736a" opacity="0.6"/>
  </svg>
);

// Subscription/Star icon
export const SubscriptionIcon = ({ size = 48 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
    <polygon
      points="24,4 29,18 44,18 32,28 36,42 24,34 12,42 16,28 4,18 19,18"
      fill="#f7c948"
      stroke="#d4a832"
      strokeWidth="1.5"
    />
    <circle cx="24" cy="22" r="4" fill="#d4736a" opacity="0.8"/>
  </svg>
);

// Data/Storage icon
export const DataIcon = ({ size = 48 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
    <ellipse cx="24" cy="12" rx="16" ry="6" fill="#fffef9" stroke="#3d3d3d" strokeWidth="1.5"/>
    <path d="M8 12 L8 36 Q8 42, 24 42 Q40 42, 40 36 L40 12" stroke="#3d3d3d" strokeWidth="1.5" fill="none"/>
    <ellipse cx="24" cy="36" rx="16" ry="6" fill="none" stroke="#3d3d3d" strokeWidth="1.5"/>
    <path d="M8 24 Q8 30, 24 30 Q40 30, 40 24" stroke="#e8e8e8" strokeWidth="1.5" fill="none"/>
    <circle cx="16" cy="12" r="2" fill="#d4736a"/>
    <circle cx="24" cy="12" r="2" fill="#f7c948"/>
    <circle cx="32" cy="12" r="2" fill="#5a8f5a"/>
  </svg>
);

// STAR Examples - Star with checkmark
export const StarIcon = ({ size = 48 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
    <polygon
      points="24,4 29,18 44,18 32,28 36,42 24,34 12,42 16,28 4,18 19,18"
      fill="#f7c948"
      stroke="#d4a832"
      strokeWidth="1.5"
    />
    <path d="M18 24 L22 28 L30 18" stroke="#3d3d3d" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Clipboard/Prep Document
export const ClipboardIcon = ({ size = 48 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
    <rect x="10" y="8" width="28" height="36" rx="2" fill="#fffef9" stroke="#3d3d3d" strokeWidth="1.5"/>
    <rect x="16" y="4" width="16" height="8" rx="2" fill="#f7c948" stroke="#d4a832" strokeWidth="1"/>
    <path d="M16 20 L32 20" stroke="#e8e8e8" strokeWidth="2" strokeLinecap="round"/>
    <path d="M16 26 L28 26" stroke="#d4736a" strokeWidth="2" strokeLinecap="round"/>
    <path d="M16 32 L30 32" stroke="#e8e8e8" strokeWidth="2" strokeLinecap="round"/>
    <path d="M16 38 L24 38" stroke="#e8e8e8" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

// Lightbulb - Ideas/Suggestions
export const LightbulbIcon = ({ size = 48 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
    <path d="M24 6 Q36 6, 36 20 Q36 28, 30 32 L30 38 L18 38 L18 32 Q12 28, 12 20 Q12 6, 24 6" fill="#f7c948" stroke="#d4a832" strokeWidth="1.5"/>
    <rect x="18" y="38" width="12" height="4" fill="#e8e8e8" stroke="#3d3d3d" strokeWidth="1"/>
    <path d="M20 42 L20 44 Q20 46, 24 46 Q28 46, 28 44 L28 42" fill="#3d3d3d"/>
    <path d="M18 26 L30 26" stroke="#d4a832" strokeWidth="1" strokeDasharray="2 2"/>
    <path d="M24 2 L24 4" stroke="#d4736a" strokeWidth="2" strokeLinecap="round"/>
    <path d="M38 12 L40 10" stroke="#d4736a" strokeWidth="2" strokeLinecap="round"/>
    <path d="M8 10 L10 12" stroke="#d4736a" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

// Lightning - Quick Sprint/Fast
export const LightningIcon = ({ size = 48 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
    <polygon points="28,4 12,26 22,26 18,44 36,20 26,20" fill="#f7c948" stroke="#d4a832" strokeWidth="1.5" strokeLinejoin="round"/>
    <path d="M22 18 L26 14" stroke="#fffef9" strokeWidth="2" strokeLinecap="round" opacity="0.6"/>
  </svg>
);

// Rocket - Projects/Launch
export const RocketIcon = ({ size = 48 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
    <path d="M24 4 Q36 8, 36 24 L36 32 L28 40 L24 36 L20 40 L12 32 L12 24 Q12 8, 24 4" fill="#fffef9" stroke="#3d3d3d" strokeWidth="1.5"/>
    <circle cx="24" cy="18" r="4" fill="#d4736a"/>
    <path d="M12 28 L6 32 L8 24" fill="#f7c948" stroke="#d4a832" strokeWidth="1"/>
    <path d="M36 28 L42 32 L40 24" fill="#f7c948" stroke="#d4a832" strokeWidth="1"/>
    <path d="M20 40 L24 44 L28 40" fill="#d4736a" stroke="#c4635a" strokeWidth="1"/>
    <path d="M22 44 L24 48 L26 44" fill="#f7c948"/>
  </svg>
);

// Lock - Pro/Premium Feature
export const LockIcon = ({ size = 48 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
    <rect x="12" y="20" width="24" height="20" rx="3" fill="#f7c948" stroke="#d4a832" strokeWidth="1.5"/>
    <path d="M16 20 L16 14 Q16 6, 24 6 Q32 6, 32 14 L32 20" fill="none" stroke="#3d3d3d" strokeWidth="2.5" strokeLinecap="round"/>
    <circle cx="24" cy="30" r="3" fill="#3d3d3d"/>
    <path d="M24 33 L24 36" stroke="#3d3d3d" strokeWidth="2.5" strokeLinecap="round"/>
  </svg>
);

// Check/Success
export const CheckIcon = ({ size = 48 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
    <circle cx="24" cy="24" r="18" fill="#5a8f5a" opacity="0.15"/>
    <circle cx="24" cy="24" r="18" stroke="#5a8f5a" strokeWidth="2"/>
    <path d="M14 24 L21 31 L34 16" stroke="#5a8f5a" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Trophy/Achievement - Brag Book
export const TrophyIcon = ({ size = 48 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
    <path d="M14 8 L34 8 L32 24 Q32 32, 24 32 Q16 32, 16 24 L14 8" fill="#f7c948" stroke="#d4a832" strokeWidth="1.5"/>
    <path d="M14 10 L8 10 Q6 10, 6 14 L6 18 Q6 22, 12 22" stroke="#d4a832" strokeWidth="1.5" fill="none"/>
    <path d="M34 10 L40 10 Q42 10, 42 14 L42 18 Q42 22, 36 22" stroke="#d4a832" strokeWidth="1.5" fill="none"/>
    <rect x="20" y="32" width="8" height="4" fill="#3d3d3d"/>
    <rect x="16" y="36" width="16" height="4" rx="1" fill="#d4736a" stroke="#c4635a" strokeWidth="1"/>
    <path d="M24 14 L25.5 18 L30 18 L26.5 21 L28 26 L24 23 L20 26 L21.5 21 L18 18 L22.5 18 Z" fill="#fffef9" opacity="0.8"/>
  </svg>
);

// Chat/Feedback
export const ChatIcon = ({ size = 48 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
    <path d="M8 8 L40 8 L40 32 L24 32 L14 42 L14 32 L8 32 Z" fill="#fffef9" stroke="#3d3d3d" strokeWidth="1.5"/>
    <circle cx="16" cy="20" r="2.5" fill="#d4736a"/>
    <circle cx="24" cy="20" r="2.5" fill="#f7c948"/>
    <circle cx="32" cy="20" r="2.5" fill="#5a8f5a"/>
  </svg>
);

// Target/Goal
export const TargetIcon = ({ size = 48 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
    <circle cx="24" cy="24" r="18" stroke="#e8e8e8" strokeWidth="2"/>
    <circle cx="24" cy="24" r="12" stroke="#f7c948" strokeWidth="2"/>
    <circle cx="24" cy="24" r="6" stroke="#d4736a" strokeWidth="2"/>
    <circle cx="24" cy="24" r="2" fill="#d4736a"/>
    <path d="M24 2 L24 6" stroke="#3d3d3d" strokeWidth="2" strokeLinecap="round"/>
    <path d="M24 42 L24 46" stroke="#3d3d3d" strokeWidth="2" strokeLinecap="round"/>
    <path d="M2 24 L6 24" stroke="#3d3d3d" strokeWidth="2" strokeLinecap="round"/>
    <path d="M42 24 L46 24" stroke="#3d3d3d" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

// Tools/Wrench - Skills
export const ToolsIcon = ({ size = 48 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
    <path d="M12 36 L20 28 L28 36 L20 44 Z" fill="#3d3d3d" stroke="#2d2d2d" strokeWidth="1"/>
    <rect x="18" y="4" width="12" height="28" rx="2" fill="#f7c948" stroke="#d4a832" strokeWidth="1" transform="rotate(45 24 18)"/>
    <circle cx="24" cy="18" r="3" fill="#d4736a"/>
    <path d="M34 12 L40 6" stroke="#3d3d3d" strokeWidth="2" strokeLinecap="round"/>
    <path d="M38 10 L42 10 L42 14" stroke="#3d3d3d" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Planning/Calendar
export const PlanningIcon = ({ size = 48 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
    <rect x="6" y="10" width="36" height="32" rx="2" fill="#fffef9" stroke="#3d3d3d" strokeWidth="1.5"/>
    <path d="M6 18 L42 18" stroke="#3d3d3d" strokeWidth="1.5"/>
    <rect x="14" y="6" width="4" height="8" rx="1" fill="#d4736a"/>
    <rect x="30" y="6" width="4" height="8" rx="1" fill="#d4736a"/>
    <rect x="10" y="22" width="8" height="6" rx="1" fill="#f7c948" opacity="0.8"/>
    <rect x="20" y="22" width="8" height="6" rx="1" fill="#e8e8e8"/>
    <rect x="30" y="22" width="8" height="6" rx="1" fill="#e8e8e8"/>
    <rect x="10" y="30" width="8" height="6" rx="1" fill="#e8e8e8"/>
    <rect x="20" y="30" width="8" height="6" rx="1" fill="#d4736a" opacity="0.8"/>
    <rect x="30" y="30" width="8" height="6" rx="1" fill="#e8e8e8"/>
  </svg>
);

// Sparkle/Magic - Customized
export const SparkleIcon = ({ size = 48 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
    <path d="M24 4 L26 14 L36 12 L28 20 L36 28 L26 26 L24 36 L22 26 L12 28 L20 20 L12 12 L22 14 Z" fill="#f7c948" stroke="#d4a832" strokeWidth="1"/>
    <circle cx="24" cy="20" r="4" fill="#d4736a"/>
    <circle cx="38" cy="8" r="3" fill="#d4736a" opacity="0.6"/>
    <circle cx="10" cy="38" r="2" fill="#f7c948" opacity="0.6"/>
    <circle cx="40" cy="36" r="2.5" fill="#5a8f5a" opacity="0.6"/>
  </svg>
);

// Small inline icons for UI elements (24px versions)
export const SmallResumeIcon = () => (
  <svg width="20" height="20" viewBox="0 0 48 48" fill="none" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
    <rect x="10" y="6" width="24" height="32" rx="2" fill="#fffef9" stroke="#3d3d3d" strokeWidth="2"/>
    <path d="M14 14 L26 14" stroke="#e8e8e8" strokeWidth="3" strokeLinecap="round"/>
    <path d="M14 22 L30 22" stroke="#d4736a" strokeWidth="3" strokeLinecap="round"/>
    <path d="M14 30 L24 30" stroke="#e8e8e8" strokeWidth="3" strokeLinecap="round"/>
  </svg>
);

export const SmallTargetIcon = () => (
  <svg width="20" height="20" viewBox="0 0 48 48" fill="none" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
    <circle cx="24" cy="24" r="16" stroke="#e8e8e8" strokeWidth="3"/>
    <circle cx="24" cy="24" r="10" stroke="#3d3d3d" strokeWidth="2" opacity="0.6"/>
    <circle cx="24" cy="24" r="5" fill="#d4736a"/>
  </svg>
);

export const SmallChartIcon = () => (
  <svg width="20" height="20" viewBox="0 0 48 48" fill="none" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
    <path d="M12 36 L12 26" stroke="#3d3d3d" strokeWidth="5" strokeLinecap="round" opacity="0.4"/>
    <path d="M24 36 L24 18" stroke="#d4736a" strokeWidth="5" strokeLinecap="round"/>
    <path d="M36 36 L36 10" stroke="#f7c948" strokeWidth="5" strokeLinecap="round"/>
  </svg>
);

export const SmallRadarIcon = () => (
  <svg width="20" height="20" viewBox="0 0 48 48" fill="none" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
    <circle cx="24" cy="24" r="16" stroke="#e8e8e8" strokeWidth="2"/>
    <circle cx="24" cy="24" r="10" stroke="#f7c948" strokeWidth="2"/>
    <circle cx="24" cy="24" r="4" fill="#d4736a"/>
    <path d="M24 8 L24 24" stroke="#3d3d3d" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

// Small inline versions (16-20px)
export const SmallStarIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
    <polygon points="24,4 29,18 44,18 32,28 36,42 24,34 12,42 16,28 4,18 19,18" fill="#f7c948" stroke="#d4a832" strokeWidth="2"/>
  </svg>
);

export const SmallClipboardIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
    <rect x="10" y="8" width="28" height="36" rx="2" fill="#fffef9" stroke="#3d3d3d" strokeWidth="2"/>
    <rect x="16" y="4" width="16" height="8" rx="2" fill="#f7c948"/>
    <path d="M16 20 L32 20" stroke="#d4736a" strokeWidth="3" strokeLinecap="round"/>
    <path d="M16 28 L28 28" stroke="#e8e8e8" strokeWidth="3" strokeLinecap="round"/>
  </svg>
);

export const SmallLightbulbIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
    <path d="M24 6 Q36 6, 36 20 Q36 28, 30 32 L30 38 L18 38 L18 32 Q12 28, 12 20 Q12 6, 24 6" fill="#f7c948" stroke="#d4a832" strokeWidth="2"/>
    <rect x="18" y="38" width="12" height="6" fill="#3d3d3d"/>
  </svg>
);

export const SmallLightningIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
    <polygon points="28,4 12,26 22,26 18,44 36,20 26,20" fill="#f7c948" stroke="#d4a832" strokeWidth="2"/>
  </svg>
);

export const SmallRocketIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
    <path d="M24 4 Q36 8, 36 24 L36 32 L28 40 L24 36 L20 40 L12 32 L12 24 Q12 8, 24 4" fill="#fffef9" stroke="#3d3d3d" strokeWidth="2"/>
    <circle cx="24" cy="18" r="4" fill="#d4736a"/>
    <path d="M20 40 L24 46 L28 40" fill="#f7c948"/>
  </svg>
);

export const SmallLockIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
    <rect x="12" y="20" width="24" height="20" rx="3" fill="#f7c948" stroke="#d4a832" strokeWidth="2"/>
    <path d="M16 20 L16 14 Q16 6, 24 6 Q32 6, 32 14 L32 20" fill="none" stroke="#3d3d3d" strokeWidth="3"/>
    <circle cx="24" cy="30" r="3" fill="#3d3d3d"/>
  </svg>
);

export const SmallCheckIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
    <circle cx="24" cy="24" r="18" fill="#5a8f5a" opacity="0.2"/>
    <path d="M14 24 L21 31 L34 16" stroke="#5a8f5a" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const SmallTrophyIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
    <path d="M14 8 L34 8 L32 24 Q32 32, 24 32 Q16 32, 16 24 L14 8" fill="#f7c948" stroke="#d4a832" strokeWidth="2"/>
    <rect x="20" y="32" width="8" height="4" fill="#3d3d3d"/>
    <rect x="16" y="36" width="16" height="4" rx="1" fill="#d4736a"/>
  </svg>
);

export const SmallChatIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
    <path d="M8 8 L40 8 L40 32 L24 32 L14 42 L14 32 L8 32 Z" fill="#fffef9" stroke="#3d3d3d" strokeWidth="2"/>
    <circle cx="16" cy="20" r="3" fill="#d4736a"/>
    <circle cx="24" cy="20" r="3" fill="#f7c948"/>
    <circle cx="32" cy="20" r="3" fill="#5a8f5a"/>
  </svg>
);

export const SmallSparkleIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
    <path d="M24 4 L26 14 L36 12 L28 20 L36 28 L26 26 L24 36 L22 26 L12 28 L20 20 L12 12 L22 14 Z" fill="#f7c948" stroke="#d4a832" strokeWidth="1.5"/>
  </svg>
);

export const SmallProfileIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
    <circle cx="24" cy="16" r="8" fill="#fffef9" stroke="#3d3d3d" strokeWidth="2"/>
    <path d="M10 44 Q10 30, 24 30 Q38 30, 38 44" fill="#f7c948" stroke="#d4a832" strokeWidth="1.5"/>
    <circle cx="24" cy="16" r="4" fill="#d4736a" opacity="0.6"/>
  </svg>
);

// ===== OUTCOME CARD ICONS =====

// Match Score - "Know before you apply" - Gauge with match percentage
export const MatchScoreIcon = ({ size = 48 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
    {/* Gauge background arc */}
    <path d="M8 32 A18 18 0 0 1 40 32" stroke="#e8e8e8" strokeWidth="4" strokeLinecap="round" fill="none"/>
    {/* Gauge filled arc (showing ~75% match) */}
    <path d="M8 32 A18 18 0 0 1 36 16" stroke="#5a8f5a" strokeWidth="4" strokeLinecap="round" fill="none"/>
    {/* Gauge needle */}
    <path d="M24 32 L30 18" stroke="#3d3d3d" strokeWidth="2.5" strokeLinecap="round"/>
    <circle cx="24" cy="32" r="4" fill="#d4736a"/>
    {/* Checkmark badge */}
    <circle cx="38" cy="12" r="7" fill="#5a8f5a"/>
    <path d="M35 12 L37 14.5 L42 9" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    {/* Missing indicator */}
    <circle cx="10" cy="14" r="4" fill="#f7c948" opacity="0.8"/>
    <path d="M10 12 L10 15" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
    <circle cx="10" cy="17" r="0.8" fill="white"/>
  </svg>
);

// Tailored Resume - "One resume won't cut it" - Multiple docs with transformation sparkle
export const TailoredResumeIcon = ({ size = 48 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
    {/* Background resume (faded) */}
    <rect x="6" y="10" width="18" height="24" rx="2" fill="#f5f5f5" stroke="#d0d0d0" strokeWidth="1"/>
    <path d="M10 16 L18 16" stroke="#e0e0e0" strokeWidth="2" strokeLinecap="round"/>
    <path d="M10 20 L20 20" stroke="#e0e0e0" strokeWidth="2" strokeLinecap="round"/>
    {/* Middle resume */}
    <rect x="14" y="6" width="18" height="24" rx="2" fill="#fffef9" stroke="#c9a87c" strokeWidth="1.5"/>
    <path d="M18 12 L26 12" stroke="#e8e8e8" strokeWidth="2" strokeLinecap="round"/>
    <path d="M18 16 L28 16" stroke="#e8e8e8" strokeWidth="2" strokeLinecap="round"/>
    {/* Front resume (optimized) */}
    <rect x="22" y="12" width="18" height="24" rx="2" fill="#fffef9" stroke="#3d3d3d" strokeWidth="1.5"/>
    <path d="M26 18 L34 18" stroke="#d4736a" strokeWidth="2" strokeLinecap="round"/>
    <path d="M26 22 L36 22" stroke="#5a8f5a" strokeWidth="2" strokeLinecap="round"/>
    <path d="M26 26 L32 26" stroke="#e8e8e8" strokeWidth="2" strokeLinecap="round"/>
    <path d="M26 30 L35 30" stroke="#5a8f5a" strokeWidth="2" strokeLinecap="round"/>
    {/* Sparkle/magic indicator */}
    <path d="M40 8 L41 11 L44 10 L42 13 L45 14 L42 15 L44 18 L41 17 L40 20 L39 17 L36 18 L38 15 L35 14 L38 13 L36 10 L39 11 Z" fill="#f7c948" stroke="#d4a832" strokeWidth="0.5"/>
  </svg>
);

// Opportunity Tracker - "Never lose track" - Clean board with status indicators
export const OpportunityTrackerIcon = ({ size = 48 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
    {/* Main board */}
    <rect x="4" y="8" width="40" height="32" rx="3" fill="#fffef9" stroke="#3d3d3d" strokeWidth="1.5"/>
    {/* Header bar */}
    <rect x="4" y="8" width="40" height="8" rx="3" fill="#3d3d3d"/>
    <path d="M4 16 L44 16" stroke="#3d3d3d" strokeWidth="1.5"/>
    {/* Column dividers */}
    <path d="M17 16 L17 40" stroke="#e8e8e8" strokeWidth="1" strokeDasharray="3 2"/>
    <path d="M31 16 L31 40" stroke="#e8e8e8" strokeWidth="1" strokeDasharray="3 2"/>
    {/* Applied column */}
    <circle cx="10" cy="12" r="2" fill="#f7c948"/>
    <rect x="7" y="20" width="7" height="5" rx="1" fill="#f7c948" opacity="0.8"/>
    <rect x="7" y="27" width="7" height="5" rx="1" fill="#f7c948" opacity="0.6"/>
    {/* Interview column */}
    <circle cx="24" cy="12" r="2" fill="#d4736a"/>
    <rect x="20" y="20" width="8" height="5" rx="1" fill="#d4736a" opacity="0.8"/>
    {/* Offer column */}
    <circle cx="38" cy="12" r="2" fill="#5a8f5a"/>
    <rect x="34" y="20" width="7" height="5" rx="1" fill="#5a8f5a" opacity="0.8"/>
    {/* Next step arrow */}
    <path d="M36 35 L40 35" stroke="#5a8f5a" strokeWidth="2" strokeLinecap="round"/>
    <path d="M38 33 L40 35 L38 37" stroke="#5a8f5a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Growth Feedback - "Turn rejections into growth" - Upward arrow with learning loop
export const GrowthFeedbackIcon = ({ size = 48 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
    {/* Circular feedback loop */}
    <path d="M16 36 Q6 30, 10 20 Q14 10, 26 10" stroke="#e8e8e8" strokeWidth="2" strokeLinecap="round" fill="none" strokeDasharray="4 2"/>
    {/* X mark (rejection) fading */}
    <path d="M12 28 L16 32" stroke="#d4736a" strokeWidth="2" strokeLinecap="round" opacity="0.4"/>
    <path d="M16 28 L12 32" stroke="#d4736a" strokeWidth="2" strokeLinecap="round" opacity="0.4"/>
    {/* Growth chart bars */}
    <rect x="22" y="30" width="5" height="10" rx="1" fill="#e8e8e8"/>
    <rect x="29" y="24" width="5" height="16" rx="1" fill="#f7c948"/>
    <rect x="36" y="16" width="5" height="24" rx="1" fill="#5a8f5a"/>
    {/* Upward arrow */}
    <path d="M38 8 L38 16" stroke="#5a8f5a" strokeWidth="3" strokeLinecap="round"/>
    <path d="M34 12 L38 8 L42 12" stroke="#5a8f5a" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
    {/* Lightbulb insight */}
    <circle cx="18" cy="16" r="5" fill="#f7c948" opacity="0.9"/>
    <path d="M16 22 L20 22" stroke="#d4a832" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M17 24 L19 24" stroke="#d4a832" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

// Bridge Gap - "Close the gap, fast" - Building blocks closing a gap
export const BridgeGapIcon = ({ size = 48 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
    {/* Left platform (current skills) */}
    <rect x="4" y="28" width="14" height="12" rx="1" fill="#3d3d3d"/>
    <rect x="6" y="30" width="10" height="3" rx="0.5" fill="#5a8f5a" opacity="0.8"/>
    <rect x="6" y="35" width="8" height="3" rx="0.5" fill="#5a8f5a" opacity="0.6"/>
    {/* Right platform (target skills) */}
    <rect x="30" y="28" width="14" height="12" rx="1" fill="#3d3d3d"/>
    <rect x="32" y="30" width="10" height="3" rx="0.5" fill="#f7c948" opacity="0.8"/>
    <rect x="32" y="35" width="10" height="3" rx="0.5" fill="#f7c948" opacity="0.8"/>
    {/* Bridge blocks being built */}
    <rect x="16" y="30" width="6" height="6" rx="1" fill="#d4736a" opacity="0.9"/>
    <rect x="21" y="28" width="6" height="6" rx="1" fill="#d4736a"/>
    {/* Block being placed (animated position) */}
    <rect x="25" y="22" width="6" height="6" rx="1" fill="#d4736a" stroke="#c4635a" strokeWidth="1"/>
    {/* Motion lines for speed */}
    <path d="M33 18 L38 18" stroke="#f7c948" strokeWidth="1.5" strokeLinecap="round" opacity="0.7"/>
    <path d="M35 14 L40 14" stroke="#f7c948" strokeWidth="1.5" strokeLinecap="round" opacity="0.5"/>
    <path d="M34 22 L37 22" stroke="#f7c948" strokeWidth="1.5" strokeLinecap="round" opacity="0.3"/>
    {/* Lightning bolt for "fast" */}
    <path d="M11 12 L9 18 L12 18 L10 24" stroke="#f7c948" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Walk In Ready - "Walk in ready" - Confident person with checklist/preparation
export const WalkInReadyIcon = ({ size = 48 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
    {/* Person silhouette */}
    <circle cx="18" cy="12" r="6" fill="#3d3d3d"/>
    <path d="M8 42 L10 28 Q10 22, 18 22 Q26 22, 26 28 L28 42" fill="#3d3d3d"/>
    {/* Confidence sparkles around head */}
    <circle cx="28" cy="8" r="2" fill="#f7c948"/>
    <circle cx="8" cy="10" r="1.5" fill="#f7c948" opacity="0.7"/>
    <circle cx="10" cy="18" r="1" fill="#f7c948" opacity="0.5"/>
    {/* Prep checklist */}
    <rect x="30" y="14" width="14" height="20" rx="2" fill="#fffef9" stroke="#3d3d3d" strokeWidth="1.5"/>
    {/* Checklist items */}
    <circle cx="34" cy="20" r="2" stroke="#5a8f5a" strokeWidth="1.5" fill="none"/>
    <path d="M33 20 L33.8 21 L35.5 19" stroke="#5a8f5a" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M38 20 L42 20" stroke="#e8e8e8" strokeWidth="1.5" strokeLinecap="round"/>
    <circle cx="34" cy="26" r="2" stroke="#5a8f5a" strokeWidth="1.5" fill="none"/>
    <path d="M33 26 L33.8 27 L35.5 25" stroke="#5a8f5a" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M38 26 L42 26" stroke="#e8e8e8" strokeWidth="1.5" strokeLinecap="round"/>
    <circle cx="34" cy="32" r="2" stroke="#5a8f5a" strokeWidth="1.5" fill="none"/>
    <path d="M33 32 L33.8 33 L35.5 31" stroke="#5a8f5a" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M38 32 L41 32" stroke="#e8e8e8" strokeWidth="1.5" strokeLinecap="round"/>
    {/* Microphone for interview */}
    <ellipse cx="18" cy="36" rx="3" ry="4" fill="#d4736a"/>
    <path d="M18 40 L18 44" stroke="#3d3d3d" strokeWidth="2" strokeLinecap="round"/>
    <path d="M14 44 L22 44" stroke="#3d3d3d" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

// Default export as object for backward compatibility
const FeatureIcons = {
  analysis: <AnalysisIcon />,
  resume: <ResumeIcon />,
  insights: <InsightsIcon />,
  skills: <SkillsIcon />,
  interview: <InterviewIcon />,
  tracker: <TrackerIcon />,
  gap: <GapIcon />,
  radar: <RadarIcon />,
  settings: <SettingsIcon />,
  profile: <ProfileIcon />,
  subscription: <SubscriptionIcon />,
  data: <DataIcon />,
  star: <StarIcon />,
  clipboard: <ClipboardIcon />,
  lightbulb: <LightbulbIcon />,
  lightning: <LightningIcon />,
  rocket: <RocketIcon />,
  lock: <LockIcon />,
  check: <CheckIcon />,
  trophy: <TrophyIcon />,
  chat: <ChatIcon />,
  target: <TargetIcon />,
  tools: <ToolsIcon />,
  planning: <PlanningIcon />,
  sparkle: <SparkleIcon />,
  // Outcome card icons
  matchScore: <MatchScoreIcon />,
  tailoredResume: <TailoredResumeIcon />,
  opportunityTracker: <OpportunityTrackerIcon />,
  growthFeedback: <GrowthFeedbackIcon />,
  bridgeGap: <BridgeGapIcon />,
  walkInReady: <WalkInReadyIcon />,
};

export default FeatureIcons;
